import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';

import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { routes } from './app/app-routing.module';
import { provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app';
import { initializeFirestore, provideFirestore } from '@angular/fire/firestore';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { appProviders } from './app/app.module';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import {environment} from "./environments/environment";

if (environment.environmentAlias !== 'local') {
  Sentry.init({
    dsn: "https://9cbb2c919f23eb7f0196bcc813817c77@o4505120257015808.ingest.us.sentry.io/4509479578435584",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.replayIntegration()
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: environment.environmentAlias,
    release: environment.release,
  });
  enableProdMode();
}

// Use the bootstrapApplication method for Angular 19+
bootstrapApplication(AppComponent, {
  providers: [
    ...appProviders,
    provideAnimations(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideFirestore(() => initializeFirestore(getApp(), {
      experimentalForceLongPolling: true,
    })),
    provideStorage(() => getStorage()),
    provideAuth(() => getAuth()),
    importProvidersFrom(
      AngularFireModule.initializeApp(environment.firebaseConfig),
      AngularFirestoreModule
    )
  ]
}).catch(err => console.error(err));
